import { render, staticRenderFns } from "./ReferralProgramOwnersExtra.vue?vue&type=template&id=1addda14&scoped=true&"
import script from "./ReferralProgramOwnersExtra.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramOwnersExtra.vue?vue&type=script&lang=js&"
import style0 from "./ReferralProgramOwnersExtra.vue?vue&type=style&index=0&id=1addda14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1addda14",
  null
  
)

export default component.exports